import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const usePadsStore = create(devtools((set, get) => ({
  pads: {
    selectedSize: 'big', // 'big', 'medium', 'small'
    unit: 'mm'
  },
  setPads: (data) => set({ pads: { ...get().pads, ...data } }),
  reset: () => set({ pads: { selectedSize: 'big', unit: 'mm' } })
})));

export default usePadsStore; 